module.exports = __webpack_public_path__ + "img/pic.a5fd4739.png";